exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-3c7e7a60] {\n  font-size: 51px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1.5;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n}", ""]);

// exports
